









import { Component, Vue, Prop } from "vue-property-decorator";
import req from "@/api";
import { IShareInfo } from "@/api/types";

@Component
export default class Header extends Vue {
  @Prop()
  private newsId!: string;

  @Prop()
  private appId!: string;

  private shareInfo: IShareInfo | {} = {};

  private isShow = true;

  mounted() {
    if (window && window.ZWY_CLOUD && window.ZWY_CLOUD.isOpenInApp()) {
      this.isShow = false;
    } else {
      this.isShow = true;
      const app = document.getElementById("app") as HTMLDivElement;
      app.style.height = "calc(100vh - (100vw * 0.16))";
      app.style.width = "100%";
      app.style.position = "absolute";
      app.style.top = "16vw";
    }
    req.getShareInfo().then(res => {
      this.shareInfo = res.data;
    });
  }

  beforeDestroy() {
    this.close();
  }

  close() {
    const app = document.getElementById("app") as HTMLDivElement;
    app.style.height = "100%";
    app.style.top = "";
    this.isShow = false;
  }

  openApp() {
    const shareInfo = this.shareInfo as IShareInfo;
    if (!shareInfo.schemeUrl) {
      return (location.href = shareInfo.downloadUrl);
    }
    const Params = {
      id: this.newsId || "",
      sourceId: this.newsId || "",
      sourceType: "1",
      url: location.href,
      shareUrl: location.href
    };
    if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
      location.href = `${shareInfo.schemeUrl}/info/install/${this.appId}.html?id=${Params.id}&&&sourceId=${Params.id}&&&sourceType=1&&&url=${Params.url}&&&shareUrl=${Params.shareUrl}`;
    } else if (/(Android)/i.test(navigator.userAgent)) {
      location.href =
        shareInfo.schemeUrl.replace("http://", "").replace("com/", "com") +
        "://" +
        `?params=${JSON.stringify(Params)}`;
      setTimeout(() => {
        location.href = shareInfo.downloadUrl;
      }, 3000);
    } else {
      location.href = shareInfo.downloadUrl;
    }
  }
}
